export const LAST_ROUTE_STORAGE_KEY = 'crickarena:last_route';

export const getPersistedRoute = () => sessionStorage.getItem(LAST_ROUTE_STORAGE_KEY) || '';

export const persistRoute = (path) => {
  if (path) {
    sessionStorage.setItem(LAST_ROUTE_STORAGE_KEY, path);
  }
};
